/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';
import { UserRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { SlicedDataSource } from '@gh/core-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { UserListItem } from './office-user-list-item.model';
import { Observable } from 'rxjs';

@Injectable()
export class OfficeUserListBusinessService implements InitViewService {

  constructor(private userContext: BuilderUserContext, private userRest: UserRestService,
              private gridLayoutService: GridLayoutService) {

  }

  initView(): any {
    return {
      gridLayout: this.gridLayoutService.get(this.userContext.corporateView ? 'corporateUsers' : 'masterUsers'),
    };
  }

  findAllAsDataSource(filter: any): SlicedDataSource<UserListItem> {
    return this.userRest.findAllOfficeAsDataSource(filter);
  }

  getOfficeUserList(filter: any): Observable<UserListItem[]> {
    return this.userRest.findAllOfficeUsers(filter);
  }
}
